import React from 'react';
import PropTypes from 'prop-types';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { TextField } from '@material-ui/core';

const SearchBoxInput = ({ handleSearch, handleChange, value, styleOverrides, label, placeholder = 'Search' }) => {
    return (
        <form onSubmit={handleSearch}>
            <TextField
                id="input-with-icon-textfield"
                variant="outlined"
                size="small"
                fullWidth
                autoComplete="off"
                value={value}
                label={label}
                placeholder={placeholder}
                style={styleOverrides || { minWidth: 280 }}
                onChange={handleChange}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <SearchIcon
                                style={{ cursor: 'pointer', color: 'inherit' }}
                                onClick={handleSearch}
                                aria-label="Search"
                            />
                        </InputAdornment>
                    ),
                }}
            />
        </form>
    );
};

SearchBoxInput.propTypes = {
    handleChange: PropTypes.func.isRequired,
    handleSearch: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    styleOverrides: PropTypes.object,
    label: PropTypes.string,
    placeholder: PropTypes.string,
};


export default SearchBoxInput;